// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import '@babel/polyfill'

// Components
import "./components";

// Plugins
import "./plugins";

// Sync router with store
import { sync } from "vuex-router-sync";

// Import gql
import WHITELABEL_PROVIDER_QUERY from "@/graphql/queries/WhiteLabelProvider.gql";

// Application imports
import App from "./App";
import i18n from "@/i18n";
import router from "@/router";
import store from "@/store";
import VueClipboard from "vue-clipboard2";
import Storage from "vue-ls";
import VueLodash from "vue-lodash";
import lodash from 'lodash'
import Meta from "vue-meta";
import VueTidio from "vue-tidio";

import { createProvider } from "./vue-apollo";
import vuetify from "./plugins/vuetify";
import { setVueGtm } from "@/plugins/vue-gtm";
const VueCookie = require("vue-cookie");

// Lodash
Vue.use(VueLodash, { lodash: lodash });

// Add Moment Library
const moment = require("moment");
//require('moment/locale/en')

Vue.use(require("vue-moment"), {
  moment,
});

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;
Vue.use(VueCookie);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

// LocalStorage plugin
Vue.use(Storage, {
  namespace: "aum_app_", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
});

Vue.use(Meta);

// Google Tag
// Set in .env
if (process.env.VUE_APP_GTM) {
  setVueGtm(process.env.VUE_APP_GTM, process.env.NODE_ENV, router);
}

const apolloProvider = createProvider();
let source = process.env.VUE_APP_DOMAIN
  ? process.env.VUE_APP_DOMAIN
  : window.location.hostname;

apolloProvider.defaultClient
  .query({
    query: WHITELABEL_PROVIDER_QUERY,
    variables: {
      source: source,
    },
    fetchPolicy: "network",
  })
  .then((data) => {
    const provider = data.data.whiteLabelProvider;
    if (provider.public_config) {
      provider.public_config = JSON.parse(provider.public_config);
    }
   
    Vue.ls.set("config", provider);

    if (provider.favicon) {
      setFavicon(provider.favicon);
    }

    if (provider.public_config && provider.public_config.tidio_id) {
      setTidio(provider.public_config.tidio_id);
    }

    /* eslint-disable no-new */
    new Vue({
      i18n,
      router,
      store,
      apolloProvider: createProvider(),
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");

  })
  .catch((error) => {
    //console.log(error)
    window.location = "404.html";
  });


  function setTidio(id) {
    if (id) {
      Vue.use(VueTidio, {
        appKey: id,
        delay: 1000
      });
    }
  }
  
  function setFavicon(logo) {
    var headID = document.getElementsByTagName("head")[0];
    var link = document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.sizes = "32x32";
    link.href = logo;
    headID.appendChild(link);
  }
